"use strict";
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHeadingTag = exports.isTag = void 0;
/**
 * Type guard to determine if a `contents` node is an `@tag` statement.
 * Optionally tests tag name too, if `tagName` arg is provided.
 */
function isTag(node, tagName) {
    return node != null && node.tag != null && (tagName == null || node.tag === tagName);
}
exports.isTag = isTag;
/** Type guard to deterimine if a `contents` node is an `@#+` heading tag. */
function isHeadingTag(node) {
    return isTag(node, "heading");
}
exports.isHeadingTag = isHeadingTag;
